import { module } from 'angular';
import formSelectComponent from './form-select.component';

export default module('app')
	.component('formSelect', formSelectComponent)
	.name;
